module.exports = __webpack_public_path__ + "media/hph-26-09_academic-excellence.15876b8d.webm";